import { useFx } from '@/context/FxContext';

/** Muestra el precio de referencia en la divisa local del usuario. El cobro real es en MXN. */
export const PriceRef = ({ mxn, className = '' }) => {
  const { currency, formatRef } = useFx();
  if (currency === 'MXN') return null;
  const ref = formatRef(mxn);
  if (!ref) return null;
  return (
    <span className={`text-xs text-white/45 ${className}`} data-testid="price-ref">
      ≈ {ref} {currency}
    </span>
  );
};

export const CurrencySelector = ({ className = '' }) => {
  const { currency, setCurrency, supported } = useFx();
  return (
    <select
      value={currency}
      onChange={(e) => setCurrency(e.target.value)}
      data-testid="currency-selector"
      className={`bg-white/10 border border-white/15 text-white/80 text-xs rounded-lg px-2 py-1 focus:outline-none focus:ring-1 focus:ring-violet-500 cursor-pointer ${className}`}
      title="Moneda de referencia (el cobro es en MXN)"
    >
      {supported.map((c) => (
        <option key={c} value={c} className="bg-[#12121f] text-white">{c}</option>
      ))}
    </select>
  );
};

export default PriceRef;
